module.exports = __webpack_public_path__ + "img/yeah.0ad6a0c0.gif";